import CookieManager from './cookie_manager';
import { vpsb_lazy_load_images } from '../vpsb/lazy_loader.js';
import { vpsb_insert_human_token, show_layout_modal } from './global';
import { postPageviewWithCaution } from './lib/pageview';
import { showModal } from './lib/bootstrap_components';

function vpsbIncrementPagesInSession(cookies) {
  var numPages = cookies.get('numPagesInSession');
  if (typeof numPages !== 'undefined') {
    numPages++;
  } else {
    numPages = 1;
  }

  cookies.set('numPagesInSession', numPages, 1);
}

function setupNavigationRum() {
  let lcp;
  let navigationLoaded = false;
  let beaconSent = false;

  const sendNavigationBeacon = () => {
    if (beaconSent) return;

    beaconSent = true;
    const nav = performance.getEntriesByType('navigation')[0];
    if (!nav || Math.random() > 1.00) return;

    const fcp = performance.getEntriesByName('first-contentful-paint', 'paint')[0]?.startTime;

    fetch('/rum/navigation', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        url: location.pathname,
        viewport: `${window.innerWidth}x${window.innerHeight}`,
        fcp,
        lcp,
        ttfb: nav.responseStart,
        dns: nav.domainLookupEnd - nav.domainLookupStart,
        connect: nav.connectEnd - nav.connectStart,
        tls: nav.secureConnectionStart
          ? nav.connectEnd - nav.secureConnectionStart
          : 0,
        protocol: nav.nextHopProtocol,
        effectiveType: navigator.connection?.effectiveType,
        rtt: navigator.connection?.rtt,
        user_agent: navigator.userAgent
      }),
      keepalive: true
    });
  };

  if ('PerformanceObserver' in window) {
    const observer = new PerformanceObserver((entries) => {
      lcp = entries.getEntries().at(-1)?.startTime;
      if (navigationLoaded && lcp !== undefined) sendNavigationBeacon();
    });
    observer.observe({ type: 'largest-contentful-paint', buffered: true });
  }

  const ignoreMe = localStorage.getItem("ignoreMe");
  if (ignoreMe === 'true') {
    return;
  }

  addEventListener('load', () => {
    navigationLoaded = true;
    if (lcp !== undefined) {
      sendNavigationBeacon();
    } else {
      setTimeout(sendNavigationBeacon, 3000);
    }
  });
}

setupNavigationRum();

function csrfToken() {
  var meta = $('meta[name=csrf-token]');
  if (meta.length == 0) {
    return "";
  }
  return meta.attr('content');
}

function logAdClick() {
  $('#vpsb-square-image').on('click', (event) => {
    $.ajax({ method: "POST",
           url: `/api/pageviews/ad_click`,
           data: { advertiser: $(event.currentTarget).data('advertiser') },
           headers: { "X-CSRF-Token": csrfToken() }
    });
  });
}

function setupAdClickRedirect() {
  $('.vpsb-square-ad-form').on('submit', (e) => {
    e.preventDefault();
    const $form = $(e.currentTarget);

    const firstVisitTimestamp = localStorage.getItem("firstVisitTimestamp");
    const previousVisitTimestamp = localStorage.getItem("previousVisitTimestamp");
    const referrer = document.referrer;

    if (firstVisitTimestamp) {
      $('<input>').attr({ type: 'hidden', name: 'first_visit_timestamp_ms', value: firstVisitTimestamp }).appendTo($form);
    }
    if (previousVisitTimestamp) {
      $('<input>').attr({ type: 'hidden', name: 'previous_visit_timestamp_ms', value: previousVisitTimestamp }).appendTo($form);
    }
    if (referrer) {
      $('<input>').attr({ type: 'hidden', name: 'referrer', value: referrer }).appendTo($form);
    }

    console.log("Submitting ad click form with visit timestamps and referrer. Referrer:", referrer);
    $form.off('submit');
    $form.trigger('submit');
  });
}

function setupNavbarNewsSnippetClick() {
  $('a#news-snippet').on('click', (e) => {
    e.preventDefault();
    $.ajax({
      method: "GET",
      url: '/accounts/announcements/new_snippet',
      success: (data) => {
        showModal('#layout-modal');
        $('#layout-modal-body').html(data);

        setup_snippet_form_submit();
      },
      error: (xhr, status, error) => {
        console.error("Failed to load announcement form:", error);
      }
    });
  });
}

function setupNavbarSignOut() {
  $('.navbar').on('click', 'a[data-method="delete"]', (e) => {
    e.preventDefault();
    $.ajax({
      method: "DELETE",
      url: $(e.currentTarget).attr('href'),
      headers: { "X-CSRF-Token": csrfToken() },
      success: () => {
        Turbo.visit('/');
      },
      error: () => {
        console.error("Sign out failed");
      }
    });
  });
}

function plausiblePageview() {
  if ($('meta[name=environment]').attr('content') !== 'development') {
    plausible('pageview');
  }
}

function setupColorSchemeToggle() {
  $('#colorScheme').on('click', 'label', (e) => {
    e.stopPropagation();
  });

  $('#colorScheme').on('change', 'input[type="radio"]', (e) => {
    console.log("Color scheme changed to " + $(e.currentTarget).val());
    if ($(e.currentTarget).val() === 'dark') {
      localStorage.setItem('theme', 'dark');
      setDarkColorTheme();
    } else if ($(e.currentTarget).val() === 'light') {
      localStorage.setItem('theme', 'light');
      setLightColorTheme();
    } else if ($(e.currentTarget).val() === 'auto') {
      localStorage.setItem('theme', 'system');
      $('nav.navbar').removeClass(['navbar-light'])
      $('.sidebar').removeClass(['theme-light', 'theme-dark']);
      setSystemColorTheme();
    }
  });
}

function setupSystemColorChange() {
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      setDarkColorTheme();
    } else {
      setLightColorTheme();
    }
  });
}

function loadColorThemeFromStorage() {
  var theme = localStorage.getItem('theme');
  if (theme === 'dark') {
    setDarkColorTheme();
    $('#colorScheme input[value="dark"]').prop('checked', true);
  } else if (theme === 'light') {
    setLightColorTheme();
    $('#colorScheme input[value="light"]').prop('checked', true);
  } else {
    setSystemColorTheme();
    $('#colorScheme input[value="auto"]').prop('checked', true);
  }
}

function setSystemColorTheme() {
  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    setDarkColorTheme();
  } else {
    setLightColorTheme();
  }
}

function setLightColorTheme() {
  $('html').attr('data-theme' , 'light');
  $('nav.navbar').removeClass(['navbar-dark']).addClass(['navbar-light'])
  $('.sidebar').addClass('theme-light').removeClass('theme-dark');
}

function setDarkColorTheme() {
  $('html').attr('data-theme' , 'dark');
  $('nav.navbar').removeClass(['navbar-light']).addClass(['navbar-dark'])
  $('.sidebar').addClass('theme-dark').removeClass('theme-light');
}

function saveVisitTimestamps() {
  if (typeof(Storage) === "undefined") {
    return;
  }

  const existingTimestamp = localStorage.getItem("firstVisitTimestamp");
  const currentTimestamp = new Date().getTime();
  localStorage.setItem("previousVisitTimestamp", currentTimestamp);
  console.debug("Saved previousVisitTimestamp:", currentTimestamp);
  if (!existingTimestamp) {
    localStorage.setItem("firstVisitTimestamp", currentTimestamp);
    console.debug("Saved firstVisitTimestamp:", currentTimestamp);
  }
}

function setupFoldableParagraph() {
  $('.foldable-paragraph .fold-toggle').on('click', (e) => {
    var toggle = e.currentTarget;
    var paragraph = $(toggle).parent();
    $(toggle).toggleClass('folded');
    $(paragraph).siblings('.fold-content').first().toggleClass('folded');
  });
}

function setup_snippet_form_submit() {
  console.log("Setting up snippet form submit handler");
  $('#announcement-snippet-form').on('submit', (event) => {
    event.preventDefault();

    var hoster_id = $('select#hoster_id').val();
    var title = $('input#title').val();
    var body = $('textarea#body').val();

    $.ajax({
      method: "POST",
      url: "/accounts/announcements",
      data: {
        snippet: true,
        hoster_id: hoster_id,
        title: title,
        body: body
      },
      dataType: 'json',
      success: (response) => {
        show_layout_modal("Your snippet announcement was successfully saved.");
        console.log("Snippet announcement save success");
      },
      error: (resp, textStatus, xhr) => {
        var respBody = resp.responseJSON;
        console.log(`Snippet announcement save failure - code=${resp.status}`);
        if (respBody !== undefined) {
          if ($('#announcement-snippet-form').closest('#layout-modal').length > 0) {
            $('#announcement-snippet-form div#error-messages').html(respBody.error);
            $('#announcement-snippet-form div#error-messages').removeClass("d-none");
          } else {
            show_layout_modal(`Failed to save announcement: ${respBody.error}.`);
          }
        } else {
          show_layout_modal(`Server error: ${resp.status}`);
        }
      }
    });
  });
}

$(document).on('turbo:load', function() {
  var cookies = new CookieManager();
  vpsbIncrementPagesInSession(cookies);
  vpsb_lazy_load_images();
  setupNavbarSignOut();
  vpsb_insert_human_token('.email-subscription-form');
  vpsb_insert_human_token('.vpsb-square-ad-form');
  setupAdClickRedirect();
  setupColorSchemeToggle();
  setupSystemColorChange();
  loadColorThemeFromStorage();
  setupFoldableParagraph();
  setupNavbarNewsSnippetClick();

  history.scrollRestoration = 'auto';

  setTimeout(() => {
    postPageviewWithCaution((bot) => {
      if (!bot) plausiblePageview();
    });

    // This must happen after the Pageview reads the timestamp values from the previous visit
    // before they are updated.
    saveVisitTimestamps();
  }, 250);


  if ($("body.accounts_announcements.new_snippet").length > 0) {
    setup_snippet_form_submit();
  }
});
